<template>
<div class="container">
  <div class="row mt-4">
    <div v-if="loading" class="col-md-4 login spinspin">
    </div>
  </div>
  <div v-if="!loading" class="row mt-4">
    <div class="col-md-4 login">
      <h6>User Name or Registered Email address</h6>
      <div class="alert alert-danger" v-if="error">
        <p>{{ error }}</p>
      </div>
      <div class="form-group">
        <input
          type="text"
          class="form-control"
          placeholder="Enter your username or email"
          v-model="credentials.email"
        >
      </div>
      <div class="row mt-4">
        <div class="col-md-8">
          <button class="btn btn-primary" @click="sendRequest()">Reset Password</button>
        </div>
        <div class="col-md-4">
          <router-link to="/login">Or Login</router-link>
        </div>
      </div>
    </div>
  </div>
  <b-modal id="modal1" title="Thank you for contacting us" hide-footer @hide="modalClose">
    <h4 :class='sentClass'>{{message}}</h4>
  </b-modal>
</div>
</template>

<script>
import axios from 'axios'
export default {
  name: 'PasswordReset',
  components: {
  },
  data: function () {
    return {
      // We need to initialize the component with any
      // properties that will be used in it
      credentials: {
        email: ''
      },
      error: '',
      q: {},
      message: '',
      sentClass: '',
      loading: false,
      apiUrl: localStorage.getItem('apiURL')
    }
  },
  methods: {
    sendRequest () {
      this.loading = true
      if (this.credentials.email) {
        let uri = this.apiUrl + 'forgotpassword?email=' + this.credentials.email
        axios.post(uri, '', '').then((response) => {
          this.message = 'A password reset email has been sent to ' + this.credentials.email
          this.sentClass = 'text-success'
          this.$root.$emit('bv::show::modal', 'modal1')
        }).catch(() => {
          this.loading = true
          this.message = 'Something went wrong, did you enter the correct email address?'
          this.sentClass = 'text-danger'
          this.$root.$emit('bv::show::modal', 'modal1')
        })
      } else {
        this.loading = true
        this.message = 'Please enter a valid email address'
        this.sentClass = 'text-danger'
        this.$root.$emit('bv::show::modal', 'modal1')
      }
    },
    modalClose () {
      this.loading = false
    }
  },
  mounted: function () {
    this.q = this.$route.query
    if (this.q.email) {
      let uri = this.apiUrl + 'passwordreset?email=' + this.q.email + '&token=' + this.q.token
      axios.post(uri, '', '').then((response) => {
        this.loading = true
        this.message = 'A new password has been sent to ' + this.q.email
        this.sentClass = 'text-success'
        this.$root.$emit('bv::show::modal', 'modal1')
      }).catch(() => {
        this.loading = true
        this.message = 'Something went wrong, please try again later'
        this.sentClass = 'text-danger'
        this.$root.$emit('bv::show::modal', 'modal1')
      })
    } else {
    }
  }
}
</script>

<style>
.login {
  margin: 0 auto;
  border: solid 1px #bbbbbb;
  padding:30px 40px;
  border-radius: 5px;
  background-color: #eeeeee;
}
.spinspin {
  height:254px;
}
.spinner {
  margin: 30px auto 20px auto ;
}
</style>



// WEBPACK FOOTER //
// src/passwordreset.vue